import CustomTooltip from '../../../../components/CustomTooltip';
import { DocumentationIcon, PersonChip } from '../../../../components/buttons/IconButtons';
import CustomModal from '../../../../components/Modal/CustomModal';
import CustomCard from '../../../../components/CustomCard';
import CustomChip from '../../../../components/CustomChip';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../enums/statusColorEnum';
import { status } from '../../../../enums/statusEnum';
import DocumentationWrapper from '../CompanyDocumentation/SubComponents/DocumentationWrapper';
import { EMPTY_VALUES } from '../../../../Apis/functions';
import {CommonDocumentationApp} from "../CompanyDocumentation/Functionality/CommonDocumentationApp";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DocumentationModal = (props) => {
    const { userTypeId, item, profile, historyModel, noInformationTitle} = props;

    const {
        t,
        subView,
        handleSubViewChange
    } = CommonDocumentationApp();

    return (
        <CustomModal
            {...props}
            size='lg'
            buttonConfirm='confirm'
            confirmButton={false}
            cancelButton={false}
            topLeftHeader={
                <>
                    <div className='d-flex align-items-center pb-3'>
                        <DocumentationIcon width={32} height={32} />

                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={t('documentation')}
                                classes={'font-color-general-950 ibl-font-w-600 fs-24px text-ellipsis-1-row ml-2'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </div>
                </>
            }
            classNameBody="pt-2"
        >
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <div className='d-flex align-items-center justify-content-between m-3'>
                    <div className='d-flex align-items-center'>
                        <PersonChip className='w-32px h-32px' />
                        <p className='fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row ml-3 text-capitalize'>
                           {item.name}
                        </p>
                    </div>
                    <CustomChip
                        variant='large'
                        background={statusColor[item.statusId]}
                        fontColor={statusFontColor[item.statusId]}
                        borderColor={statusBorderColor[item.statusId]}
                        legend={t(status[item.statusId]) || EMPTY_VALUES.DEFAULT}
                    />
                </div>
                <div className={'border-bottom-shades-300'} />
                <DocumentationWrapper
                    t={t}
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    id={item?.id}
                    userTypeId={userTypeId}
                    profile={profile}
                    historyModel={historyModel}
                    noInformationTitle={noInformationTitle}
                />
            </CustomCard>
        </CustomModal>
    );
};

export default DocumentationModal;
